import axios from "axios";
import { signOutAndRedirect } from "./jwt";
import { baseUrl } from "../config";

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// Add token to requests
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken"); // or from Redux

  // Ensure headers object exists
  if (!config.headers) {
    config.headers = {};
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Handle responses and errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const err = error?.response?.data;

    // Handle JWT expiration error (typically 401 with message "jwt expired")
    if (error?.response?.status === 401) {
      // Check for JWT expiration or other authorization issues
      if (err?.message === "jwt expired" || err?.name === "TokenExpiredError") {
        // This function should handle token cleanup and redirection
        signOutAndRedirect();
      }
    }

    // Return the original error for consistent error handling
    return Promise.reject(error);
  }
);

export default axiosInstance;
